import {
  CreateActionBulkDialog,
  CreateActionBulkDialogData,
} from '@aibees/elephant/components/create-action-bulk-dialog';
import { useBrowseSearchExports } from '@aibees/elephant/hooks/use-browse-search-exports';
import { notificationIconMap } from '@aibees/elephant/utils';
import { useBoolean, useNotify } from '@aibees/shared/hooks';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { random } from 'lodash-es';
import { memo } from 'react';
import { useUpdateExportApi } from '../../api/use-update-export-api';
import type { EditExportDialogProps as Props } from './types';

export const EditExportDialog = memo(({ className, item, state }: Props) => {
  const notify = useNotify();
  const api = useUpdateExportApi(item.id);

  const loading = useBoolean();

  const handleClose = () => {
    state.onFalse();
  };

  const handleSubmit = (data: CreateActionBulkDialogData) => {
    loading.onTrue();
    api
      .mutateAsync({ ...item, ...data, name: data.name })
      .then(() => {
        loading.onToggle();
        handleClose();
        notify.complete(
          'Export Name Updated',
          'Name changed successfully.',
          random(1, 101),
          {
            icon: notificationIconMap.EXPORT,
          }
        );
        return baseQueryClient.invalidateQueries([useBrowseSearchExports.name]);
      })
      .catch(() => {
        loading.onFalse();
      })
      .finally(loading.onFalse);
  };

  return (
    <CreateActionBulkDialog
      state={state}
      id={item.id}
      title="Edit Export Name"
      icon="edit-outline"
      inputTitle="Export Name:"
      isEdit
      hasVisibility={false}
      defaultValue={item.name}
      loading={api.isLoading}
      onClick={handleSubmit}
    />
  );
});

EditExportDialog.displayName = 'EditExportDialog';
